import React from 'react';
import NavbarComponent from './components/NavBar';
import Cover from './components/Cover';
import About from './components/About';
import WorkExperience from './components/WorkExperience';
import Projects from './components/Projects';
import Education from './components/Education';
import Contact from './components/Contact';
import Loading,{loadingListener} from './components/Loading';

function App() {
  React.useEffect(() => {
    
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth",
        });
      });
    });

    loadingListener();
  }, []);

  return (
    <div className="App">
      <Loading/>
      <NavbarComponent/>
      <Cover/>
      <About/>    
      <WorkExperience/>
      <Projects/>
      <Education/>
      <Contact/>
    </div>
  );
}

export default App;
